import { render } from "./StatisticsDashboard.vue?vue&type=template&id=0a9975de&scoped=true&ts=true"
import script from "./StatisticsDashboard.vue?vue&type=script&lang=ts"
export * from "./StatisticsDashboard.vue?vue&type=script&lang=ts"

import "./StatisticsDashboard.vue?vue&type=style&index=0&id=0a9975de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a9975de"]])

export default __exports__